var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEbt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59166 16.1914H2.08775V18.8164H6.18346V20H0.605331V11.4688H6.14244V12.6641H2.08775V15.0195H5.59166V16.1914Z",
    fill: "#5D6B72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69049 20V11.4688H10.6143C11.5792 11.4688 12.3135 11.6621 12.8174 12.0488C13.3213 12.4355 13.5733 13.0117 13.5733 13.7773C13.5733 14.168 13.4678 14.5195 13.2569 14.832C13.046 15.1445 12.7374 15.3867 12.3311 15.5586C12.7921 15.6836 13.1475 15.9199 13.3975 16.2676C13.6514 16.6113 13.7784 17.0254 13.7784 17.5098C13.7784 18.3105 13.5206 18.9258 13.0049 19.3555C12.4932 19.7852 11.7588 20 10.8018 20H7.69049ZM9.17291 16.1504V18.8164H10.8194C11.2842 18.8164 11.6475 18.7012 11.9092 18.4707C12.171 18.2402 12.3018 17.9199 12.3018 17.5098C12.3018 16.623 11.8487 16.1699 10.9424 16.1504H9.17291ZM9.17291 15.0605H10.626C11.087 15.0605 11.4463 14.957 11.7042 14.75C11.9659 14.5391 12.0967 14.2422 12.0967 13.8594C12.0967 13.4375 11.9756 13.1328 11.7335 12.9453C11.4952 12.7578 11.1221 12.6641 10.6143 12.6641H9.17291V15.0605Z",
    fill: "#5D6B72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5608 12.6641H18.9006V20H17.4299V12.6641H14.7932V11.4688H21.5608V12.6641Z",
    fill: "#5D6B72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.17063e-08 9C0.940513 3.87976 5.42648 0 10.8186 0C16.2108 0 20.6967 3.87976 21.6372 9H18.8245C17.9306 5.41005 14.6853 2.75 10.8186 2.75C6.95198 2.75 3.70663 5.41005 2.81271 9H-1.17063e-08Z",
    fill: "#5D6B72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbt);
export default __webpack_public_path__ + "static/media/EBT.20217a13.svg";
export { ForwardRef as ReactComponent };